module.exports = __webpack_public_path__ + "static/media/product.0b91071b.svg";